import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsSkus(
  goodsId,
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/skus`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _generateGoodsSkus(
  goodsId, values,
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/skus`,
    method: 'post',
    data: values,
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSku(goodsSkuId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-skus/${goodsSkuId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  image
 * @param  price
 * @param  quantity
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsSku(
  {
    image,
    price,
    code,
    // modelSizeImage,
    // modelSizeDetail,
    description,
    images,
    // modelImages,
    quantity,
    // storageBin,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-skus`,
    method: 'post',
    data: {
      image,
      price,
      code,
      // modelSizeImage,
      // modelSizeDetail,
      description,
      images,
      // modelImages,
      quantity,
      // storageBin,
    },
  });
}

/**
 * 更新
 * @param goodsSkuId
 * @param  image
 * @param  price
 * @param  quantity
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsSku(goodsSkuId, {
  image,
  price,
  code,
  // modelSizeImage,
  // modelSizeDetail,
  description,
  images,
  // modelImages,
  quantity,
  storageBin,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-skus/${goodsSkuId}`,
    method: 'patch',
    data: {
      image,
      price,
      code,
      // modelSizeImage,
      // modelSizeDetail,
      description,
      images,
      // modelImages,
      quantity,
      // storageBin,
    },
  });
}

/**
 * 删除
 * @param goodsSkuId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSku(goodsSkuId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-skus/${goodsSkuId}`,
    method: 'delete',
  });
}

export default {};
